module.exports = __webpack_public_path__ + "static/media/pegaso_new.597f5d59.svg";